// const calculateExpirePlan = (subscriptionStart, planDuration, planType) => {
//     if (!subscriptionStart || planType === 'free' || planDuration === 'lifetime') {
//         return false; // Not expired
//     }

//     // Convert Firestore Timestamp to JS Date if necessary
//     const startDate = subscriptionStart.toDate ? subscriptionStart.toDate() : new Date(subscriptionStart);
//     if (isNaN(startDate.getTime())) return false; // Invalid date handling

//     const currentDate = new Date();
//     const expireDate = new Date(startDate);

//     if (planDuration === 'monthly') {
//         expireDate.setMonth(startDate.getMonth() + 1);
//     } else if (planDuration === 'yearly') {
//         expireDate.setFullYear(startDate.getFullYear() + 1);
//     } else {
//         return false; // Unknown duration
//     }

//     return currentDate > expireDate;
// };

// export default calculateExpirePlan;
export const calculateExpirePlan = (subscriptionEnd, planType) => {
    // Free or lifetime plans never expire
    if (!subscriptionEnd || planType === 'free' || planType === 'lifetime') {
        return false;
    }

    // Convert Firestore Timestamp → JS Date
    const endDate = subscriptionEnd.toDate
        ? subscriptionEnd.toDate()
        : new Date(subscriptionEnd);

    if (isNaN(endDate.getTime())) return false;

    const currentDate = new Date();

    return currentDate > endDate;
};




export const calculateSubscriptionEnd = (subscriptionStart, planDuration, planType) => {
    // Free or lifetime plans do not have an end date
    if (!subscriptionStart || planType === 'free' || planDuration === 'lifetime') {
        return null;
    }



    // Convert Firestore Timestamp → JS Date
    const startDate = subscriptionStart.toDate
        ? subscriptionStart.toDate()
        : new Date(subscriptionStart);

    if (isNaN(startDate.getTime())) return null;

    const endDate = new Date(startDate);

    if (planDuration === 'monthly') {
        endDate.setMonth(endDate.getMonth() + 1);
    } else if (planDuration === 'yearly') {
        endDate.setFullYear(endDate.getFullYear() + 1);
    } else {
        return null;
    }

    return endDate;
};


